import api from '../../plugins/api';

// POST /api/crm/vin-blacklist â Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð¾Ð´Ð¸Ð½ VIN Ñ Ð¿ÑÐ¸ÑÐ¸Ð½Ð¾Ð¹. Ð£Ð¶Ðµ Ð² ÑÐ¿Ð¸ÑÐºÐµ â 409.
const addVinToBlacklist = ({ vin, reason }) => {
  return api.post('/api/crm/vin-blacklist', { vin, reason });
};

export default addVinToBlacklist;
